import React from "react";

function CommercialLaw() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Commercial Law</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              A close understanding of a client’s business is a key factor for this area of practice.  That essentially means maintaining close relationships with the client.  
              </p>
              <p>
              The range of clients spurs from all backgrounds.  This usually involves heavy documentation and overlaps with many other areas of law such as property, construction and employment. Types of work can come from any area of business which makes this an unforeseeable type of practice.
              </p>
              <p>
              Commercial awareness is the main requirement in this area as it is the doorway to getting around problems and creating more profit opportunities for the client.  The lawyer himself must have been involved in the market to have that kind of necessary awareness.
              </p>
              <p>
              A commercial lawyer will usually spearhead the team of lawyers from all sorts of legal practices to achieve the ultimate goal of the commercial client.
              </p>
              <p>
              Nabeel Saeed has been the head of various legal departments therefore making him the ideal candidate for commercial awareness.  Much of our day to day work is commercial law related; it fascinates us how under this one umbrella so many different types of work can be included and yet be labeled as none other than commercial law.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default CommercialLaw;
